module.exports = __webpack_public_path__ + "img/23.7ffd06e4.png";